// extracted by mini-css-extract-plugin
module.exports = {"switch":"todolist_switch__3OOfP","slider":"todolist_slider__2qP_6","round":"todolist_round__3WilL"};